module.exports = __webpack_public_path__ + "static/media/facebook.b33c9ba2.svg";